/* eslint react/jsx-props-no-spreading: ["off"] */

import React from 'react'
import { Chip as MaterialChip } from '@material-ui/core'

export default function Chip(props) {
  return (
    <MaterialChip {...props} />
  )
}
